import { render, staticRenderFns } from "./copy-fee.vue?vue&type=template&id=569f409e&scoped=true&"
import script from "./copy-fee.vue?vue&type=script&lang=js&"
export * from "./copy-fee.vue?vue&type=script&lang=js&"
import style0 from "./copy-fee.vue?vue&type=style&index=0&id=569f409e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f409e",
  null
  
)

export default component.exports